<template>
  <div class="box10">
    <pageTitle
      title="大厂共建课程<br/>打造硬核技术竞争力"
      text="四大优势叠加，求职竞争力拉满"
      titleColor="#24375c"
      titColor="#86909C"
    />

    <div class="card-grid">
      <div
        class="card"
        v-for="(item, index) in cardList"
        :key="index"
        :class="[
          item.theme === 'blue' ? 'card--blue' : 'card--purple',
          item.tall ? 'card--tall' : '',
        ]"
      >
        <h3 class="card__title">{{ item.title }}</h3>
        <div class="card__body">
          <p class="card__text">
            <span class="card__desc" v-html="item.desc"></span>
            <span
              class="card__highlight"
              :class="
                item.theme === 'blue'
                  ? 'card__highlight--blue'
                  : 'card__highlight--purple'
              "
              v-html="item.highlight"
              ></span
            >
          </p>
        </div>
      </div>
    </div>

    <div class="logo-bar">
      <img
        class="logo-bar__img"
        src="../../../assets/coursePage/llm/box10/logos.png"
        alt=""
      />
    </div>

    <ConsultBtn text="申请免费试听" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import ConsultBtn from "./ConsultBtn.vue";

export default {
  components: {
    pageTitle,
    ConsultBtn,
  },
  data() {
    return {
      cardList: [
        {
          title: "大厂前沿技术",
          desc: "科大讯飞、腾讯云、阿里云等大厂最新AI技术。",
          highlight: "提前掌握行业前沿技术栈，学用不脱节",
          theme: "blue",
          tall: false,
        },
        {
          title: "大厂开发环境",
          desc: "阿里云PAI、腾讯云等专属GPU算力资源，完成企业级开发部署全流程，",
          highlight: "积累项目经验",
          theme: "purple",
          tall: false,
        },
        {
          title: "大厂权威认证",
          desc: "科大讯飞四大行业认证（Prompt/微调/智能体/RAG工程师认证），",
          highlight: "简历多一份硬核背书，提升求职通过率",
          theme: "blue",
          tall: true,
        },
        {
          title: "大厂面试题库",
          desc: "AI岗位面试真题，考点技术解析与项目复盘。<br/>",
          highlight: "掌握大厂面试逻辑与高频考点，从容拿下高薪<br/>offer",
          theme: "purple",
          tall: true,
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box10 {
  position: relative;
  padding: 80px 32px;
  width: 100%;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/llm/box10/bg.png") no-repeat top
    center;
  background-size: 100% auto;
  background-color: #f3f6ff;

  /deep/ .course-title-box {
    position: relative;
    z-index: 1;
  }

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 40px;
    margin-top: 14px;
  }

  .card-grid {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: start;
    gap: 30px;
    margin-top: 48px;
  }

  .card {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding-top: 20px;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
    border-radius: 34px;
    overflow: hidden;
    box-shadow: 0 0.106667rem 0.266667rem 0 rgba(210, 227, 241, 0.77);

    &--blue {
      background-image: url("../../../assets/coursePage/llm/box10/card-bg-blue.png");
    }

    &--purple {
      background-image: url("../../../assets/coursePage/llm/box10/card-bg-purple.png");
    }

    &__title {
      position: relative;
      z-index: 1;
      margin: 0;
      padding: 0 32px;
      font-family: PingFangSC, PingFang SC;
      font-size: 32px;
      font-weight: 700;
      color: #072557;
      line-height: 56px;
    }

    &__body {
      position: relative;
      z-index: 1;
      margin-top: 16px;
      padding: 26px 32px;
      background: #ffffff;
      border-radius: 34px;
    }

    &__text {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #072557;
      line-height: 40px;
    }

    &__desc {
      color: #072557;
    }

    &__highlight {
      font-weight: 500;

      &--blue {
        color: #096be6;
      }

      &--purple {
        color: #8a3eda;
      }
    }
  }

  .logo-bar {
    position: relative;
    z-index: 1;
    margin-top: 28px;
    padding: 0;
    border-radius: 20px;
    background: #ffffff;
    box-shadow: 0 8px 20px 0 rgba(210, 227, 241, 0.77);
    overflow: hidden;

    &__img {
      display: block;
      width: 100%;
      height: 82px;
      object-fit: contain;
    }
  }

}
</style>
